const es = {
    message: {
        title1:'Control remoto del hogar inteligente, tecnología, seguridad y tranquilidad',
        content1:'AigoSmart lo ayuda a administrar y controlar de forma remota los electrodomésticos inteligentes, y los dispositivos también pueden percibirse y vincularse entre sí. El disparo con un clic puede hacer que todos los electrodomésticos entren en su estado preestablecido, creando un hogar inteligente seguro y sin preocupaciones para usted vida. ',
        title2: "AigoSmart es una nueva submarca de Aigostar",
        content2: "Los productos se venden actualmente a España, Portugal, Francia, Italia, Países Bajos, Alemania, Finlandia, Dinamarca, Polonia, Rusia, Grecia, Austria, Suiza, República Checa, Hungría, Eslovaquia y otros países y regiones de Europa.",
        content3: "Los diversos electrodomésticos de cocina, lavandería y planchado de AIGOSTAR siguen ocupando",
        content4: "Diez principales ventas",
        title3: "Honor de la marca",
        content5: "Rápido. Abrir. Innovar. Perseverar",
        loading:'Cargando',
        submit:'enviar',
        contactUs: "Contáctenos",
        privacy:"Acuerdo de privacidad",
        policy:"Política de servicio",
        download:"Descargar",

    },
}

export default es;